import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";

import Endpoints from "../Endpoints";

/**
 * @param {{ params?: object, query: { customerId: string } }} option
 */
export const GetPayTypes = async (option) => {
  const response = await $api.get(Endpoints.BillOperation.GetPayTypes(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

/**
 * @param {{ params?: object, query: { customerId: string, payTypeId: number } }} option
 */
export const GetPaymentTypes = async (option) => {
  const response = await $api.get(
    Endpoints.BillOperation.GetPaymentTypes(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

/**
 * @param {{ params?: object, query: { customerId: string, payTypeId: number, paymentTypeId: number } }} option
 */
export const GetDiscountTypes = async (option) => {
  const response = await $api.get(
    Endpoints.BillOperation.GetDiscountTypes(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

/**
 * @param {{ params?: object, query: { customerId: string } }} option
 */
export const GetSpecialDiscounts = async (option) => {
  const response = await $api.get(
    Endpoints.BillOperation.GetSpecialDiscounts(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

/**
 * Özel indirim sonrası tutar (query alanları backend ile uyumlu olmalıdır).
 *
 * @param {{ params?: object, query: Record<string, string|number> }} option
 */
export const GetSpecialDiscountTotalPrice = async (option) => {
  const response = await $api.get(
    Endpoints.BillOperation.GetSpecialDiscountTotalPrice(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

/** Sunucunun seçili kart/senet için hesapladığı taksit seçenekleri. */
export const GetInstallmentOptions = async (form) => {
  const response = await $api.post(
    Endpoints.BillOperation.GetInstallmentOptions(),
    form
  );
  return ResponseChecker(defaultMessages, response);
};

/** Seçilen ödeme planının sunucu taraflı taksit ve toplam önizlemesi. */
export const PreviewPaymentPlan = async (form) => {
  const response = await $api.post(
    Endpoints.BillOperation.PreviewPaymentPlan(),
    form
  );
  return ResponseChecker(defaultMessages, response);
};

/**
 * Fatura / sepet akışından sipariş oluşturur.
 * Ham API yanıtı döner (ResponseChecker kullanılmaz; çift modal ve özel data parse için).
 *
 * @param {object} form - CreateOrder body (checkoutPays, planId, customerId, …)
 */
export const CreateOrder = async (form) => {
  const response = await $api.post(
    Endpoints.BillOperation.CreateOrder({ params: {}, query: {} }),
    form
  );
  return response;
};

export default {
  GetPayTypes,
  GetPaymentTypes,
  GetDiscountTypes,
  GetSpecialDiscounts,
  GetSpecialDiscountTotalPrice,
  GetInstallmentOptions,
  PreviewPaymentPlan,
  CreateOrder,
};
